// V9 motion release: 2026-07-20
(function () {
  'use strict';

  function all(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  var menuButton = document.querySelector('[data-menu-button]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  function closeMenu() {
    if (!menuButton || !mobileNav) return;
    mobileNav.hidden = true;
    menuButton.setAttribute('aria-expanded', 'false');
  }

  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', function () {
      var opening = mobileNav.hidden;
      mobileNav.hidden = !opening;
      menuButton.setAttribute('aria-expanded', opening ? 'true' : 'false');
    });
    all('a', mobileNav).forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  all('[data-language-selector]').forEach(function (selector) {
    selector.addEventListener('change', function () {
      if (selector.form) selector.form.submit();
    });
  });

  all('.work-order-form [required]').forEach(function (field, index) {
    var errorId = (field.id || 'InquiryField' + index) + '-error';

    function errorContainer() {
      return field.closest('.field-group') || field.closest('.consent-field');
    }

    function showFieldError() {
      var container = errorContainer();
      if (!container) return;
      var message = container.parentElement.querySelector('#' + errorId);
      if (!message) {
        message = document.createElement('small');
        message.id = errorId;
        message.className = 'field-error-message';
        container.insertAdjacentElement('afterend', message);
      }
      message.textContent = field.validationMessage;
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-describedby', errorId);
    }

    function clearFieldError() {
      if (!field.validity.valid) return;
      var message = document.getElementById(errorId);
      if (message) message.remove();
      field.removeAttribute('aria-invalid');
      field.removeAttribute('aria-describedby');
    }

    field.addEventListener('invalid', showFieldError);
    field.addEventListener('input', clearFieldError);
    field.addEventListener('change', clearFieldError);
  });

  function clamp(value, minimum, maximum) {
    return Math.max(minimum, Math.min(maximum, value));
  }

  function heroCarouselRoots(context) {
    var roots = all('[data-hero-carousel]', context || document);
    if (context && context.matches && context.matches('[data-hero-carousel]')) roots.unshift(context);
    return roots;
  }

  function initHeroCarousel(root) {
    if (!root || root.dataset.heroCarouselInitialized === 'true') return;

    var slides = all('[data-carousel-slide]', root);
    var dots = all('[data-carousel-dot]', root);
    var status = root.querySelector('[data-carousel-status]');
    if (!slides.length || slides.length !== dots.length) return;

    root.dataset.heroCarouselInitialized = 'true';
    var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var currentIndex = 0;
    var timer = 0;
    var hoverPaused = false;
    var focusPaused = false;
    var touchStartX = null;
    var touchStartY = null;
    var dotHandlers = [];

    slides.forEach(function (slide, index) {
      if (slide.classList.contains('is-active')) currentIndex = index;
    });

    function stopTimer() {
      if (timer) clearInterval(timer);
      timer = 0;
    }

    function loadSlideImage(slide) {
      var image = slide && slide.querySelector('[data-carousel-image]');
      if (!image || image.dataset.imageLoaded === 'true') return;
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.src) image.src = image.dataset.src;
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
      image.dataset.imageLoaded = 'true';
    }

    function showSlide(index, announce) {
      currentIndex = (index + slides.length) % slides.length;
      loadSlideImage(slides[currentIndex]);
      if (!reduceQuery.matches && slides.length > 1) loadSlideImage(slides[(currentIndex + 1) % slides.length]);
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === currentIndex;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('tabindex');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');
        }
      });
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (announce && status) status.textContent = slides[currentIndex].dataset.productName || '';
    }

    function startTimer() {
      stopTimer();
      if (slides.length < 2 || reduceQuery.matches || hoverPaused || focusPaused) return;
      timer = setInterval(function () {
        showSlide(currentIndex + 1, false);
      }, 5000);
    }

    function restartTimer() {
      stopTimer();
      startTimer();
    }

    function handleMouseEnter() {
      hoverPaused = true;
      stopTimer();
    }

    function handleMouseLeave() {
      hoverPaused = false;
      startTimer();
    }

    function handleFocusIn() {
      focusPaused = true;
      stopTimer();
    }

    function handleFocusOut(event) {
      if (event.relatedTarget && root.contains(event.relatedTarget)) return;
      focusPaused = false;
      startTimer();
    }

    function handleKeyDown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var moveFocus = document.activeElement === slides[currentIndex];
      showSlide(currentIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
      if (moveFocus) slides[currentIndex].focus();
      restartTimer();
    }

    function resetTouch() {
      touchStartX = null;
      touchStartY = null;
    }

    function handleTouchStart(event) {
      if (event.touches.length !== 1) {
        resetTouch();
        return;
      }
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }

    function handleTouchEnd(event) {
      if (touchStartX === null || touchStartY === null || !event.changedTouches.length) {
        resetTouch();
        return;
      }
      var deltaX = event.changedTouches[0].clientX - touchStartX;
      var deltaY = event.changedTouches[0].clientY - touchStartY;
      resetTouch();
      if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      if (event.cancelable) event.preventDefault();
      showSlide(currentIndex + (deltaX < 0 ? 1 : -1), true);
      restartTimer();
    }

    function handleMotionPreference() {
      root.dataset.reducedMotion = reduceQuery.matches ? 'true' : 'false';
      if (!reduceQuery.matches && slides.length > 1) loadSlideImage(slides[(currentIndex + 1) % slides.length]);
      startTimer();
    }

    dots.forEach(function (dot, index) {
      var handler = function () {
        showSlide(index, true);
        restartTimer();
      };
      dotHandlers.push(handler);
      dot.addEventListener('click', handler);
    });

    root.addEventListener('mouseenter', handleMouseEnter);
    root.addEventListener('mouseleave', handleMouseLeave);
    root.addEventListener('focusin', handleFocusIn);
    root.addEventListener('focusout', handleFocusOut);
    root.addEventListener('keydown', handleKeyDown);
    root.addEventListener('touchstart', handleTouchStart, { passive: true });
    root.addEventListener('touchend', handleTouchEnd);
    root.addEventListener('touchcancel', resetTouch, { passive: true });
    if (reduceQuery.addEventListener) reduceQuery.addEventListener('change', handleMotionPreference);
    else reduceQuery.addListener(handleMotionPreference);

    showSlide(currentIndex, false);
    handleMotionPreference();

    root._heroCarouselCleanup = function () {
      stopTimer();
      root.removeEventListener('mouseenter', handleMouseEnter);
      root.removeEventListener('mouseleave', handleMouseLeave);
      root.removeEventListener('focusin', handleFocusIn);
      root.removeEventListener('focusout', handleFocusOut);
      root.removeEventListener('keydown', handleKeyDown);
      root.removeEventListener('touchstart', handleTouchStart);
      root.removeEventListener('touchend', handleTouchEnd);
      root.removeEventListener('touchcancel', resetTouch);
      dots.forEach(function (dot, index) {
        dot.removeEventListener('click', dotHandlers[index]);
      });
      if (reduceQuery.removeEventListener) reduceQuery.removeEventListener('change', handleMotionPreference);
      else reduceQuery.removeListener(handleMotionPreference);
      root.removeAttribute('data-hero-carousel-initialized');
      root._heroCarouselCleanup = null;
    };
  }

  heroCarouselRoots(document).forEach(initHeroCarousel);

  document.addEventListener('shopify:section:load', function (event) {
    heroCarouselRoots(event.target).forEach(initHeroCarousel);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    heroCarouselRoots(event.target).forEach(function (root) {
      if (event.detail && event.detail.sectionId && root.dataset.sectionId !== String(event.detail.sectionId)) return;
      if (root._heroCarouselCleanup) root._heroCarouselCleanup();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenu();
  });

  var selectorRoot = document.querySelector('[data-product-selector]');
  var inquiryModel = document.querySelector('[data-inquiry-model]');
  var inquiryHandle = document.querySelector('[data-inquiry-handle]');
  var inquiryVariant = document.querySelector('[data-inquiry-variant]');
  var inquiryVariantId = document.querySelector('[data-inquiry-variant-id]');
  var inquirySource = document.querySelector('[data-inquiry-source]');

  var attributionStoragePrefix = 'aonxin_attribution_';
  var attributionParameters = new URLSearchParams(window.location.search);

  function readSessionValue(key) {
    try { return window.sessionStorage.getItem(attributionStoragePrefix + key) || ''; }
    catch (error) { return ''; }
  }

  function writeSessionValue(key, value) {
    if (!value || readSessionValue(key)) return;
    try { window.sessionStorage.setItem(attributionStoragePrefix + key, value); }
    catch (error) { /* Attribution remains available for the current page. */ }
  }

  function createLeadId() {
    var now = new Date();
    var date = [now.getUTCFullYear(), String(now.getUTCMonth() + 1).padStart(2, '0'), String(now.getUTCDate()).padStart(2, '0')].join('');
    var random = '';
    if (window.crypto && window.crypto.getRandomValues) {
      var values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      random = values[0].toString(36).slice(0, 6).toUpperCase();
    } else {
      random = Math.random().toString(36).slice(2, 8).toUpperCase();
    }
    return 'AX-' + date + '-' + random;
  }

  writeSessionValue('lead_id', createLeadId());
  writeSessionValue('landing_page', window.location.href);
  writeSessionValue('referrer', document.referrer);
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (key) {
    writeSessionValue(key, attributionParameters.get(key));
  });

  function setAttributionField(selector, value) {
    var field = document.querySelector(selector);
    if (field && value && !field.value) field.value = value;
  }

  setAttributionField('[data-attribution-lead-id]', readSessionValue('lead_id') || createLeadId());
  setAttributionField('[data-attribution-submitted-page]', window.location.href);
  setAttributionField('[data-attribution-landing-page]', readSessionValue('landing_page') || window.location.href);
  setAttributionField('[data-attribution-referrer]', readSessionValue('referrer') || document.referrer || 'Direct / unavailable');
  setAttributionField('[data-attribution-utm-source]', readSessionValue('utm_source') || attributionParameters.get('utm_source'));
  setAttributionField('[data-attribution-utm-medium]', readSessionValue('utm_medium') || attributionParameters.get('utm_medium'));
  setAttributionField('[data-attribution-utm-campaign]', readSessionValue('utm_campaign') || attributionParameters.get('utm_campaign'));
  setAttributionField('[data-attribution-utm-term]', readSessionValue('utm_term') || attributionParameters.get('utm_term'));
  setAttributionField('[data-attribution-utm-content]', readSessionValue('utm_content') || attributionParameters.get('utm_content'));
  setAttributionField('[data-attribution-language]', document.documentElement.lang || 'en');

  if (inquiryModel && !inquiryModel.value && inquiryModel.dataset.inquiryDefaultModel) {
    inquiryModel.value = inquiryModel.dataset.inquiryDefaultModel;
  }

  function machineLabel(card) {
    if (!card) return '';
    var code = card.dataset.code || '';
    var title = card.dataset.title || '';
    return (code ? code + ' — ' : '') + title;
  }

  function setInquiryContext(context) {
    context = context || {};
    if (inquiryModel && context.model !== undefined) inquiryModel.value = context.model;
    if (inquiryHandle && context.handle !== undefined) inquiryHandle.value = context.handle;
    if (inquiryVariant && context.variant !== undefined) inquiryVariant.value = context.variant;
    if (inquiryVariantId && context.variantId !== undefined) inquiryVariantId.value = context.variantId;
    if (inquirySource && context.source !== undefined) inquirySource.value = context.source;
  }

  function setInquiryModel(card) {
    if (!card) return;
    setInquiryContext({
      model: machineLabel(card),
      handle: card.dataset.handle || '',
      variant: '',
      variantId: '',
      source: window.location.href
    });
  }

  function setText(root, selector, value, fallback) {
    var element = root.querySelector(selector);
    if (element) element.textContent = value || fallback;
  }

  function selectMachine(card, updateInquiry) {
    if (!selectorRoot || !card) return;
    all('[data-machine-card]', selectorRoot).forEach(function (item) {
      var active = item === card;
      item.classList.toggle('is-active', active);
      var selectButton = item.querySelector('[data-machine-select]');
      if (selectButton) selectButton.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });

    var code = card.dataset.code || '';
    var title = card.dataset.title || '';
    setText(selectorRoot, '[data-product-code]', code, selectorRoot.dataset.modelFallback);
    setText(selectorRoot, '[data-product-width]', card.dataset.width, selectorRoot.dataset.confirmWithQuote);
    setText(selectorRoot, '[data-product-depth]', card.dataset.depth, selectorRoot.dataset.confirmWithQuote);
    setText(selectorRoot, '[data-product-hp]', card.dataset.hp, selectorRoot.dataset.engineeringReview);
    setText(selectorRoot, '[data-product-linkage]', card.dataset.linkage, selectorRoot.dataset.modelDependent);
    setText(selectorRoot, '[data-product-weight]', card.dataset.weight, selectorRoot.dataset.confirmWithQuote);
    setText(selectorRoot, '[data-product-wear]', card.dataset.wear, selectorRoot.dataset.availableWithQuote);

    var details = selectorRoot.querySelector('[data-product-link]');
    if (details) {
      details.href = card.dataset.url || '#inquiry';
      details.textContent = card.dataset.url ? selectorRoot.dataset.fullDetails : selectorRoot.dataset.requestDatasheet;
    }
    var quote = selectorRoot.querySelector('[data-product-quote]');
    if (quote) quote.textContent = selectorRoot.dataset.requestQuote + ' — ' + (code || title);
    if (updateInquiry !== false) setInquiryModel(card);
  }

  if (selectorRoot) {
    all('[data-machine-card]', selectorRoot).forEach(function (card) {
      var selectButton = card.querySelector('[data-machine-select]');
      if (selectButton) selectButton.addEventListener('click', function () { selectMachine(card); });
    });
    var firstCard = selectorRoot.querySelector('[data-machine-card]');
    if (firstCard) selectMachine(firstCard, false);

    all('[data-machine-filter]', selectorRoot).forEach(function (filterButton) {
      filterButton.addEventListener('click', function () {
        var category = filterButton.dataset.machineFilter || 'all';
        all('[data-machine-filter]', selectorRoot).forEach(function (button) {
          var active = button === filterButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        var visibleCards = [];
        all('[data-machine-card]', selectorRoot).forEach(function (card) {
          var visible = category === 'all' || card.dataset.machineCategory === category;
          card.hidden = !visible;
          if (visible) visibleCards.push(card);
        });

        var activeCard = selectorRoot.querySelector('[data-machine-card].is-active:not([hidden])');
        if (!activeCard && visibleCards.length) selectMachine(visibleCards[0]);
      });
    });

    var selectorQuote = selectorRoot.querySelector('[data-product-quote]');
    if (selectorQuote) {
      selectorQuote.addEventListener('click', function () {
        setInquiryModel(selectorRoot.querySelector('[data-machine-card].is-active'));
      });
    }
  }

  var inquiryParameters = new URLSearchParams(window.location.search);
  var inquiryModelFromUrl = inquiryParameters.get('inquiry_model');
  var inquiryHandleFromUrl = inquiryParameters.get('inquiry_handle');
  var inquiryVariantFromUrl = inquiryParameters.get('inquiry_variant');
  var inquiryVariantIdFromUrl = inquiryParameters.get('inquiry_variant_id');
  var inquirySourceFromUrl = inquiryParameters.get('inquiry_source');
  if (inquiryModelFromUrl || inquiryHandleFromUrl || inquiryVariantFromUrl || inquiryVariantIdFromUrl || inquirySourceFromUrl) {
    setInquiryContext({
      model: inquiryModelFromUrl || '',
      handle: inquiryHandleFromUrl || '',
      variant: inquiryVariantFromUrl || '',
      variantId: inquiryVariantIdFromUrl || '',
      source: inquirySourceFromUrl || window.location.href
    });
  } else if (inquirySource && !inquirySource.value) {
    inquirySource.value = window.location.href;
  }

  function productQuoteContext(quote) {
    var selectId = quote.dataset.inquiryVariantSelect;
    var select = selectId ? document.getElementById(selectId) : null;
    var option = select && select.options[select.selectedIndex];
    return {
      model: quote.dataset.inquiryModel || '',
      handle: quote.dataset.inquiryHandle || '',
      variant: option ? option.textContent.trim() : (quote.dataset.inquiryDefaultVariant || ''),
      variantId: option ? option.value : (quote.dataset.inquiryDefaultVariantId || ''),
      source: quote.dataset.inquirySource || window.location.href
    };
  }

  function syncProductQuote(quote) {
    var context = productQuoteContext(quote);
    var url = new URL(quote.getAttribute('href') || window.location.href, window.location.origin);
    url.searchParams.set('inquiry_model', context.model);
    url.searchParams.set('inquiry_handle', context.handle);
    url.searchParams.set('inquiry_variant', context.variant);
    url.searchParams.set('inquiry_variant_id', context.variantId);
    url.searchParams.set('inquiry_source', context.source);
    url.hash = 'inquiry';
    quote.href = url.pathname + url.search + url.hash;
  }

  all('[data-product-quote-button]').forEach(function (quote) {
    syncProductQuote(quote);
    var selectId = quote.dataset.inquiryVariantSelect;
    var select = selectId ? document.getElementById(selectId) : null;
    if (select) select.addEventListener('change', function () { syncProductQuote(quote); });
    quote.addEventListener('click', function () { syncProductQuote(quote); });
  });

  function projectFitRoots(context) {
    var roots = all('[data-project-fit]', context || document);
    if (context && context.matches && context.matches('[data-project-fit]')) roots.unshift(context);
    return roots;
  }

  function initProjectFit(root) {
    if (!root || root.dataset.projectFitInitialized === 'true') return;

    var diagram = root.querySelector('[data-road-animation]');
    var working = root.querySelector('[data-road-working]');
    var rotor = root.querySelector('.road-rotor');
    var power = root.querySelector('[data-fit-power]');
    var depth = root.querySelector('[data-fit-depth]');
    var depthOutput = root.querySelector('[data-fit-depth-output]');
    var roadPowerOutput = root.querySelector('[data-road-power-output]');
    var roadDepthOutput = root.querySelector('[data-road-depth-visual-output]');
    var powerMeter = root.querySelector('[data-road-power-meter]');
    var engineeringSelection = root.querySelector('[data-engineering-selection]');
    var addRequirement = root.querySelector('[data-fit-inquiry]');

    if (!diagram || !working || !rotor || !power || !depth) return;

    root.dataset.projectFitInitialized = 'true';
    var inquiryPower = document.querySelector('[data-inquiry-power]');
    var inquiryRequirement = document.querySelector('[data-inquiry-requirement]');
    var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var observer = null;
    var resizeObserver = null;
    var replayRequest = 0;
    var resizeRequest = 0;
    var isVisible = false;
    var depthTemplate = root.dataset.targetDepthNote || 'Target working depth: {depth} mm.';

    function selectedPowerText() {
      var option = power.options[power.selectedIndex];
      return option ? option.textContent.trim() : '';
    }

    function selectedPowerLevel() {
      var value = parseInt(power.value, 10);
      if (isNaN(value)) return 0;
      if (value >= 160) return 5;
      if (value >= 140) return 4;
      if (value >= 120) return 3;
      if (value >= 100) return 2;
      return 1;
    }

    function escapeRegExp(value) {
      return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function depthNotePattern() {
      var token = '__AONXIN_DEPTH__';
      var escaped = escapeRegExp(depthTemplate.replace('{depth}', token));
      return new RegExp('^' + escaped.replace(token, '\\d+(?:[.,]\\d+)?') + '$', 'i');
    }

    function updateVisualization() {
      var depthValue = clamp(parseInt(depth.value, 10) || 0, parseInt(depth.min, 10) || 0, parseInt(depth.max, 10) || 350);
      var depthMaximum = parseInt(depth.max, 10) || 350;
      var powerText = selectedPowerText();
      var powerLevel = selectedPowerLevel();
      var workingHeight = working.clientHeight || 112;
      var rotorSize = rotor.offsetHeight || 78;
      var penetration = (depthValue / depthMaximum) * Math.max(workingHeight - 8, 0);
      var trackTop = working.offsetTop + penetration - rotorSize;
      var depthLabelTop = clamp(penetration - 18, 2, Math.max(workingHeight - 20, 2));

      if (depthOutput) depthOutput.textContent = depthValue;
      if (roadPowerOutput) roadPowerOutput.textContent = powerText;
      if (roadDepthOutput) roadDepthOutput.textContent = depthValue;
      if (engineeringSelection) {
        engineeringSelection.textContent = (root.dataset.powerLabel || 'Tractor power') + ' · ' + powerText + '  |  ' + (root.dataset.depthLabel || 'Target working depth') + ' · ' + depthValue + ' mm';
      }

      if (powerMeter) {
        all('i', powerMeter).forEach(function (bar, index) {
          bar.classList.toggle('is-active', index < powerLevel);
        });
      }

      diagram.dataset.powerLevel = String(powerLevel);
      diagram.dataset.targetDepth = String(depthValue);
      diagram.style.setProperty('--road-depth-line', penetration.toFixed(2) + 'px');
      diagram.style.setProperty('--road-depth-label-top', depthLabelTop.toFixed(2) + 'px');
      diagram.style.setProperty('--road-track-top', trackTop.toFixed(2) + 'px');
    }

    function stopRoadAnimation() {
      if (replayRequest) cancelAnimationFrame(replayRequest);
      replayRequest = 0;
      diagram.classList.remove('is-road-animated');
    }

    function replayRoadAnimation() {
      stopRoadAnimation();
      if (!isVisible || reduceQuery.matches) return;
      replayRequest = requestAnimationFrame(function () {
        replayRequest = 0;
        if (!isVisible || reduceQuery.matches) return;
        void diagram.offsetWidth;
        diagram.classList.add('is-road-animated');
      });
    }

    function handleDepthInput() {
      updateVisualization();
    }

    function handleDepthChange() {
      updateVisualization();
      replayRoadAnimation();
    }

    function handlePowerChange() {
      updateVisualization();
      replayRoadAnimation();
    }

    function handleMotionPreference() {
      updateVisualization();
      if (reduceQuery.matches) stopRoadAnimation();
      else replayRoadAnimation();
    }

    function handleAddRequirement() {
      if (inquiryPower) inquiryPower.value = selectedPowerText();
      if (!inquiryRequirement) return;

      var note = depthTemplate.replace('{depth}', depth.value);
      var pattern = depthNotePattern();
      var lines = inquiryRequirement.value.split(/\r?\n/).filter(function (line) {
        return !pattern.test(line.trim());
      });
      while (lines.length && !lines[0].trim()) lines.shift();
      while (lines.length && !lines[lines.length - 1].trim()) lines.pop();
      lines.push(note);
      inquiryRequirement.value = lines.join('\n');
    }

    function scheduleVisualization() {
      if (resizeRequest) return;
      resizeRequest = requestAnimationFrame(function () {
        resizeRequest = 0;
        updateVisualization();
      });
    }

    depth.addEventListener('input', handleDepthInput);
    depth.addEventListener('change', handleDepthChange);
    power.addEventListener('change', handlePowerChange);
    if (addRequirement) addRequirement.addEventListener('click', handleAddRequirement);
    if (reduceQuery.addEventListener) reduceQuery.addEventListener('change', handleMotionPreference);
    else reduceQuery.addListener(handleMotionPreference);

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== diagram) return;
          isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.3;
          if (isVisible) replayRoadAnimation();
          else stopRoadAnimation();
        });
      }, { threshold: 0.3 });
      observer.observe(diagram);
    } else {
      isVisible = true;
      replayRoadAnimation();
    }

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(scheduleVisualization);
      resizeObserver.observe(working);
    } else {
      window.addEventListener('resize', scheduleVisualization, { passive: true });
    }

    updateVisualization();

    root._projectFitCleanup = function () {
      stopRoadAnimation();
      if (resizeRequest) cancelAnimationFrame(resizeRequest);
      if (observer) observer.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      else window.removeEventListener('resize', scheduleVisualization);
      depth.removeEventListener('input', handleDepthInput);
      depth.removeEventListener('change', handleDepthChange);
      power.removeEventListener('change', handlePowerChange);
      if (addRequirement) addRequirement.removeEventListener('click', handleAddRequirement);
      if (reduceQuery.removeEventListener) reduceQuery.removeEventListener('change', handleMotionPreference);
      else reduceQuery.removeListener(handleMotionPreference);
      root.removeAttribute('data-project-fit-initialized');
    };
  }

  projectFitRoots(document).forEach(initProjectFit);

  document.addEventListener('shopify:section:load', function (event) {
    projectFitRoots(event.target).forEach(initProjectFit);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    projectFitRoots(event.target).forEach(function (root) {
      if (root._projectFitCleanup) root._projectFitCleanup();
    });
  });
})();
